import React from 'react';
import Skeleton from './Skeleton';

/**
 * Loading state: skeleton by default for heavy blocks; classic wait text via variant="wait".
 */
export default function LoadingWait({ minHeight = 280, variant = 'skeleton', rows = 4 }) {
  if (variant === 'wait') {
    return (
      <div
        className="loading-wait-wrap"
        style={{ minHeight }}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div className="loading-wait-inner">
          <span className="loading-wait-text">Загрузка... ожидайте</span>
          <span className="loading-wait-dots" aria-hidden>
            <i /><i /><i />
          </span>
        </div>
      </div>
    );
  }

  const skVariant = variant === 'table' || variant === 'lines' ? variant : 'cards';
  return <Skeleton minHeight={minHeight} rows={rows} variant={skVariant} />;
}
